// Иконка раскрытой книги — FAQ / документация.
import React from "react";

export function BookOpenIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 5.5h7c.8 0 1.5.7 1.5 1.5v12H4c-.6 0-1-.4-1-1v-12.5Z" />
      <path d="M21 5.5h-7c-.8 0-1.5.7-1.5 1.5v12H20c.6 0 1-.4 1-1v-12.5Z" />
    </svg>
  );
}

export default BookOpenIcon;
